import React from "react";
import { useStockPoDetailModel } from "../purchaseDetailsModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel, { transOptions } from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useStockPoDetailModel();
    const { warehouseList, shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            placeholder: "是否有库存",
            fieldName: "age",
            allowClear: true,
            options: [{ label: "是", value: 1 }],
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "仓库名称",
            options: transOptions(warehouseList),
            fieldName: "warehouseCode"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "采购单号",
            fieldName: "purchaseCode"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品编号",
            fieldName: "materialCode"
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "商品名称",
            fieldName: "materialName"
        },

        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: "所属站点",
        //     fieldName: "shopId",
        //     options: allShopDs,
        //     disabled: shopType === 0 ? false : true
        // },

    ]

    const searchMoreFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "供应商名称",
            fieldName: "supplierName"
        },
    ]
    return (
        <YhPageHeader
            title="采购明细"
            size="small"

            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}